import { sendRequest } from '../base/ApiService';
import { httpMethod } from '@/shared/helpers/httpMethod.enum';

const countryBaseURL = process.env.REACT_APP_ROOT_URL + process.env.REACT_APP_BASE_INFO_ENDPOINT;

export const countryEndpoints = {
  GET_ALL_COUNTRY_LIST: '/getCountryList',
};

/**
 * get list for all countries
 */
const getCountryList = () => {
  return sendRequest({
    fullUrl: countryBaseURL + countryEndpoints.GET_ALL_COUNTRY_LIST,
    method: httpMethod.GET,
  });
};

export default {
  getCountryList,
};
